<template>
  <div class="wrapper">
    <div>
      <v-tags></v-tags>
      <v-slider></v-slider>
      <div class="content-box" :class="{ 'content-collapse': collapse }">
        <div class="content" :style="{'padding': isPadding ? '10px' : '0'}">
          <!-- <router-view v-slot="{ Component }">
            <transition name="move" mode="out-in">
              <keep-alive :include="tagsList">
                <component :is="Component"></component>
              </keep-alive>
            </transition>
          </router-view> -->
           <transition
              name="move"
              mode="out-in"
            >
            <router-view v-slot="{ Component }">
              <keep-alive :include="tagsList">
                <component :is="Component"></component>
              </keep-alive>
            </router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vTags from "@comp/Home/Tags.vue";
import vSlider from "@comp/Home/Sidebar";
export default {
  data() {
    return {
      isPadding: true,
      IsCs: false,
      tagsList: [],
      collapse: false,
      sliderState: false, //左侧默认不显示
      makerstate: false, // 遮罩层
      styleOpera: true, //新旧版样式切换  默认新版样式
      sliderleft: true,
      contentBoxnweset: false, // 菜单2.0版内容显示 默认左侧的菜单不显示
      layerNetsetState: false, // 遮罩层透明状态显示与否  默认不显示
      styleOperaNet: true,
    };
  },
  watch: {
    '$route'(to) {
      this.isPadding = to.path !== '/CourseDetail'
    }
  },
  components: {
    vTags,
    vSlider,
  },
  computed: {
    key() {
      if (this.$route.meta.breadcrumb == undefined) return "";
      else return this.$route.meta.breadcrumb.id;
    },
  },
  created() {
    this.isPadding = this.$route.path !== '/CourseDetail'
    this.emitter.on("collapse", (msg) => {
      this.collapse = msg;
    });
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    this.emitter.on("tags", (msg) => {
      let arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    });
    this.emitter.on("SwitchTags", (item) => {
      this.SwitchTags_Sider(item);
    });
  },
  methods: {
    SwitchTags_Sider(item) {
      var menuList = JSON.parse(localStorage.getItem("menus"));
      var id = item.meta.breadcrumb.id;
      var indexFristItem = -1;
      for (var i = 0; i < menuList.length; i++) {
        var jsonstring = JSON.stringify(menuList[i]);
        if (jsonstring.indexOf(id) > -1) {
          indexFristItem = i;
          break;
        }
      }
      if (indexFristItem === -1) {
        return;
      }
      var SecondMenuid = menuList[indexFristItem].id;
      var title = menuList[indexFristItem].title;
      if (this.$refs.silderHtml) {
        this.$refs.silderHtml.oneState = true; //一级菜单
        this.$refs.silderHtml.twoState = false; //二级菜单
        this.$refs.silderHtml.otherState = false; //三级菜单
        this.$refs.silderHtml.oneOperaMenu(SecondMenuid, title);
      }
    },
    menuOpera() {
      if (this.sliderleft == true) {
        this.allScreen();
      } else if (
        this.sliderleft == false &&
        this.sliderState == true &&
        this.makerstate == true
      ) {
        this.allScreen();
      } else if (
        this.sliderleft == false &&
        this.sliderState == false &&
        this.makerstate == false
      ) {
        this.allScreen();
      } else {
        this.makerstate = true;
        this.$refs.silderHtml.sliderdis();
      }
    },
    StyleMenu(flag) {
      this.$nextTick(() => {
        this.styleOpera = flag;
      });
    },
    StyleMenuSet(flag) {
      this.$nextTick(() => {
        this.styleOperaNet = flag;
      });
    },
    oneMenuOpera(flag) {
      this.makerstate = flag;
      this.sliderleft = flag;
    },
    // 新版菜单展开收起
    spreadBtn(way) {
      if (way == false) {
        // 不显示左侧菜单
        this.$refs.slidernet.newestSlider = true;
        this.contentBoxnweset = true;
        this.$refs.slidernet.searchState = false;
        this.$refs.slidernet.otherState = false;
        this.$refs.slidernet.flag = 0;
      } else {
        // 显示左侧菜单
        this.$refs.slidernet.newestSlider = false;
        this.contentBoxnweset = false;
      }
    },
    //搜索的时候遮罩层消失
    searchMenu(flag) {
      if (flag == 1) {
        this.sliderState = false;
        this.makerstate = false;
      }
      this.$refs.silderHtml.otherState = false; //三级菜单
      this.$refs.silderHtml.transparentmakerState = false;
    },
    //点击遮罩层
    btnMaker(makerstate) {
      if (
        this.sliderleft == true &&
        this.sliderState == true &&
        this.makerstate == true
      ) {
        this.allScreen();
      } else if (
        this.sliderleft == false &&
        this.sliderState == true &&
        this.makerstate == true
      ) {
        this.makerstate = false;
      }
    },
    allScreen() {
      this.sliderState = !this.sliderState;
      this.makerstate = !this.makerstate;
    },
    // 新版菜单不显示浮层
    layerNetset() {
      this.$refs.slidernet.otherState = false;
      this.$refs.slidernet.searchState = false;
      this.layerNetsetState = false;
      this.$refs.slidernet.flag = 0;
    },
    // 新版2.0菜单显示透明浮层
    bgStateOpen() {
      this.layerNetsetState = true;
    },
    // 新版2.0菜单不显示透明浮层
    bgStateClose() {
      this.layerNetsetState = false;
    },
  },
  mounted() {
    let that = this;
    if (window._IsCs) {
      that.IsCs = window._IsCs;
      const loading = this.$loading({
        lock: true,
        text: "页面加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      that.$nextTick(() => {
        let shopDB = null;
        // indexedDB.openDB(shopDB, { name: "moduleList", key: "moduleID" }, null);
        this.emitter.on("MenuLoaded", (menus) => {
          let to = that.$route.query.to;
          that.$nextTick(() => {
            that.$router.push({ name: to }).then((result) => {
              loading.close();
            });
          });
        });
      });
    }
  },
};
</script>
<style scoped>
.content-fullscreen {
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 101 !important;
}

.content-fullscreen /deep/ .frmWorkflow .main .workflow {
  top: 150px !important;
  left: 10px !important;
}
.content-boxall {
  position: absolute;
  left: 0;
  right: 0;
  top: 52px;
  bottom: 0;
  background: #f0f0f0;
  transition: all 0.25s linear;
}
.content-boxnew {
  position: absolute;
  left: 180px;
  right: 0;
  top: 52px;
  bottom: 0;
  background: #f0f0f0;
  transition: all 0.25s linear;
  padding-bottom: 36px;
}
.content-boxnweset {
  position: absolute;
  left: 208px;
  right: 0;
  top: 57px;
  bottom: 0;
  background: #f0f0f0;
  transition: all 0.25s linear;
  padding-bottom: 10px;
}
.content-boxnweset.content-boxnwesetleft {
  left: 0;
  transition: all 0.25s linear;
}
.contentmaker {
  position: absolute;
  left: 0px;
  right: 0;
  top: 52px;
  bottom: 0;
  z-index: -6;
  transition: all 0.25s linear;
}
.contentmaker-boxall {
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  left: 180px;
  right: 0;
  top: 52px;
  bottom: 0;
  z-index: 60;
  transition: all 0.25s linear;
  padding-bottom: 36px;
}

.content-box /deep/ .commonfixedopera #BtnComponent {
  position: fixed;
  top: 110px;
  z-index: 8;
  right: 24px;
  left: 260px;
  height: 64px;
}
.content-box.content-collapse /deep/ .commonfixedopera #BtnComponent {
  left: 74px !important;
}
.content-box /deep/ .commonfixedopera #BtnComponent .is-always-shadow,
.content-boxall /deep/ .commonfixedopera #BtnComponent .is-always-shadow,
.content-boxnweset /deep/ .commonfixedopera #BtnComponent .is-always-shadow,
.content-boxnew /deep/ .commonfixedopera #BtnComponent .is-always-shadow {
  box-shadow: none;
}
.content-box /deep/ .commonfixedopera .commonbase_article,
.content-boxall /deep/ .commonfixedopera .commonbase_article,
.content-boxnweset /deep/ .commonfixedopera .commonbase_article,
.content-boxnew /deep/ .commonfixedopera .commonbase_article {
  padding-top: 40px;
}
.content-boxall /deep/ .commonfixedopera #BtnComponent {
  position: fixed;
  top: 98px;
  z-index: 8;
  right: 24px;
  left: 10px;
  height: 64px;
}
.content-boxnew /deep/ .commonfixedopera #BtnComponent {
  position: fixed;
  top: 98px;
  left: 190px;
  right: 24px;
  height: 64px;
  z-index: 8;
}
.content-boxnweset /deep/ .commonfixedopera #BtnComponent {
  position: fixed;
  top: 52px;
  left: 126px;
  right: 24px;
  /* height: 64px; */
  z-index: 8;
  transition: all 0.25s linear;
}
.content-box.content-collapse .fixedskudiv,
.content-box.content-collapse /deep/ .frmWorkflow .main .workflow {
  left: 74px !important;
}
.content-boxall /deep/ .fixedskudiv {
  left: 10px !important;
}
.content-boxnew /deep/ .fixedskudiv {
  left: 190px !important;
}
.layernetset {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 3;
  background: transparent;
}
.content-boxall /deep/ .meetconditions {
  margin-left: 100px;
}
.content-boxall /deep/ .treeView {
  top: 340px;
}
.content-boxall /deep/ .gourpMain {
  top: 340px;
}
.content-boxnew /deep/ .treeView {
  top: 300px;
  left: 220px;
}
.content-boxnew /deep/ .gourpMain {
  top: 300px;
  right: 6%;
}
.content-box /deep/ .treeView {
  left: 280px;
  top: 390px;
}
.content-box /deep/ .gourpMain {
  right: 1%;
  top: 390px;
}
.content-box.content-collapse /deep/ .treeView {
  left: 100px;
  top: 310px;
}
.content-box.content-collapse /deep/ .gourpMain {
  right: 10%;
  top: 310px;
}
@media (max-width: 1367px) {
  .content-box /deep/ .commonfixedopera #BtnComponent .is-always-shadow {
    box-shadow: 230px !important;
  }
  .content-box .content /deep/ .commonfixedopera #BtnComponent {
    left: 230px !important;
  }
}
.content-boxall >>> .content {
  /* height: calc(100% - 15px); */
  height: calc(100% - 44px);
}
.content-boxnew >>> .content {
  height: calc(100% - 15px);
}

.content-boxall /deep/ .frmWorkflow .main .workflow {
  left: 10px;
}
.content-boxnew /deep/ .frmWorkflow .main .workflow {
  left: 190px;
}
.content-boxnew /deep/ .yhqzsnum {
  width: 120px;
}
.content-boxnew /deep/ .frmActiveLabel .treeView {
  max-height: 370px;
}
.content-boxnweset.content-boxnwesetleft /deep/ .frmWorkflow .main .workflow {
  top: 230px !important;
  left: 10px !important;
}
.content-boxnweset.content-boxnwesetleft
  /deep/
  .commonfixedopera
  #BtnComponent {
  left: 10px;
  transition: all 0.25s linear;
}
.content-boxnweset /deep/ .fixedskudiv,
.content-boxnweset /deep/ .frmWorkflow .main .workflow {
  left: 128px !important;
}
.content-boxall /deep/ .pzydcontent .tip,
.content-boxnew /deep/ .pzydcontent .tip {
  top: 64px;
}
.content-box /deep/ .pzydcontent .tip {
  top: 60px;
}
.content-boxall /deep/ .pzydcontent .pzmain,
.content-boxnew /deep/ .pzydcontent .pzmain,
.content-box /deep/ .pzydcontent .pzmain {
  top: 106px;
}
</style>
